<aside class="main-sidebar sidebar-light-primary elevation-4 d-md-none mt-1">

  <!-- Sidebar -->

  <div class="sidebar">

    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item"  *ngIf="isAdminMenuVisible">
          <a  [routerLink]="['/dashboard/admin']" class="nav-link">
            <i class="nav-icon pi pi-home"></i>
            <p>
              Home
              <!-- <span class="right badge badge-danger">New</span> -->
            </p>
          </a>
        </li>
        <li class="nav-item"  *ngIf="!isAdminMenuVisible">
          <a [routerLink]="['/dashboard/vendor']" class="nav-link">
            <i class="nav-icon pi pi-home"></i>
            <p>
              Home
              <!-- <span class="right badge badge-danger">New</span> -->
            </p>
          </a>
        </li>
        <li class="nav-item" *ngIf="sharedService.checkPermission('Applicant_View')">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-user"></i>
            <p>
              Applicants
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <!-- <li class="nav-item"  *ngIf="sharedService.checkPermission('Applicant_Add') && !sharedService.isMspUser()">
              <a [routerLink]="['/applicant/applicant-add']" class="nav-link">
                <p>Add Applicant</p>
              </a>
            </li> -->
            <li class="nav-item" *ngIf="sharedService.checkPermission('Applicant_View')">
              <a [routerLink]="['/applicant/applicant-search']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Submitted Applicant Search</p>
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item" *ngIf="sharedService.checkPermission('Requisition_View')">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-briefcase"></i>
            <p>
              Requisitions
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" *ngIf="sharedService.checkPermission('Requisition_View')">
              <a [routerLink]="['/requisition/requisition-search']" class="nav-link">
                 <!-- <i class="far fa-circle nav-icon"></i>  -->
                <p>Requisition Search</p>
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-dollar"></i>
            <p>
              Invoices
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item"*ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/invoice/admin']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Invoice Search</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="!isAdminMenuVisible">
              <a [routerLink]="['/invoice/vendor']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Invoice Search</p>
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-users"></i>
            <p>
              Users
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item"  *ngIf="sharedService.checkPermission('User_Add')">
              <a [routerLink]="['/users/create-user']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Create User</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="sharedService.checkPermission('User_View')"> 
              <a [routerLink]="['/users/user-search']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>User Search</p>
              </a>
            </li>
            <li class="nav-item" *ngIf=" sharedService.checkPermission('User_View')">
              <a [routerLink]="['/users/user-permissions']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Users Permissions</p>
              </a>
            </li>
            <li class="nav-item" >
              <a [routerLink]="['/users/vendor-view']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Company Profile</p>
              </a>
            </li>
            
            <li class="nav-item">
              <a [routerLink]="['/users/change-password']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Change Password</p>
              </a>
            </li>
          </ul>
        </li>
        
        <li class="nav-item"  *ngIf="isAdminMenuVisible">
          <a href="#" class="nav-link">
            <img _ngcontent-gsp-c46="" src="../../../../assets/img/employees-img.png" style="color:black;" width="17px" height="18px" alt="" class="mt-n1">
            <p>
              Vendors
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item">
              <a [routerLink]="['/admin/client-approval-search']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Client Approval</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/create-vendor']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Create Vendor</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/import-invoice-applicant']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Import Invoice Applicant</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/vendor-approval-search']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Vendor Approval</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/vendor-client-assignment']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Vendor Client Assignment</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Vendor Profile Status</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/users/vendor-search']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Vendor Search</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/admin/dvms-system-alerts']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>DVMS System Alerts</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/admin/email-channel']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Email Channel</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="isRateApporvalMenuVisible">
              <a [routerLink]="['/admin/rate-change-request']" class="nav-link">
                
                <p>Rate Change Request</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/admin/vendor-onboarding']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Vendor Onboarding</p>
              </a>
            </li>
            <li class="nav-item" *ngIf="isVendorOnboardProcessSearchMenuVisible">
              <a [routerLink]="['/admin/vendor-onboard-process-search']" class="nav-link">
                <p>Vendor Onboard Process Search</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/vendor-onboard-approval-search']" class="nav-link">
                <p>Vendor Onboard Approval Search</p>
              </a>
            </li>

          </ul>
        </li>
        
        <li class="nav-item" *ngIf="isAdminMenuVisible">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-cog"></i>
            <p>
              Admin
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item">
              <a [routerLink]="['/admin/application-features']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Application Features</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/user-role-default-features']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Users Role Default Features</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/user-claims']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>User Claims</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/lookup-master']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Lookup Mater</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/state']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>State</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/country']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Country</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/client-master']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Client Master</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/client-requisition-contact']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Client Requisition Contact</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/client-checklist']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Client Checklist</p>
              </a>
            </li>
           
            <li class="nav-item">
              <a [routerLink]="['/admin/application-claim-types']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Application Claim Types</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/claims-master']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Claims Master</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/lookup-category']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Lookup Category</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/email-template']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Email Template</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/document-template']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Document Template</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/city']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>City</p>
              </a>
            </li>          
            <li class="nav-item">
              <a [routerLink]="['/admin/email-configuration']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Email Smtp Configuration</p>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/send-email']"  class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Send Email</p>
              </a>
            </li>

          </ul>
        </li>

        <li class="nav-item" *ngIf="isAdminMenuVisible">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-chart-line"></i>
            <p>
              Reports
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item"  *ngIf="sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/report/vendor-activity']" class="nav-link">
                <p>Vendor Activity</p>
              </a>
            </li>
            <li class="nav-item"  *ngIf="sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/report/vendor-invoices']" class="nav-link">
                <p>Vendor Invoices</p>
              </a>
            </li>
            <li class="nav-item"  *ngIf="sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/report/user-activity-log']" class="nav-link">
                <p>User Activity Log</p>
              </a>
            </li>
            <li class="nav-item"  *ngIf="sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/report/email-delivery-report']" class="nav-link">
                <p>Email Delivery Report</p>
              </a>
            </li>
            <li class="nav-item"  *ngIf="sharedService.checkPermission('Admin_View')">
              <a [routerLink]="['/report/error-log']" class="nav-link">
                <p>Error Log</p>
              </a>
            </li>
           </ul>
        </li>  
        <li class="nav-item" *ngIf="sharedService.checkPermission('User_View')">
          <a href="#" class="nav-link">
            <i class="nav-icon pi pi-chart-bar"></i>
            <p>
              DVMS Improvements
              <i class="fas fa-angle-left right"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item">
              <a [routerLink]="['/users/dvms-improvements']" class="nav-link">
                <!-- <i class="far fa-circle nav-icon"></i> -->
                <p>Improvements Search</p>
              </a>
            </li>
          </ul>
        </li>      
      </ul>
    </nav>

  </div>
  <!-- /.sidebar -->
</aside>